import { ChatBubble, ContentCopy, Edit } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

import InfoBlock from '~/components/infoBlock'
import { getChatUrl } from '~/features/agents/components/agentInfoHeader/agentChatInfo/utils'
import useGetAgentCentralized from '~/features/agents/hooks/useGetAgentCentralized'
import { EAgentKeys } from '~/features/agents/models'
import { EClientPath } from '~/models/api'

type TAgentChatInfoProps = { isExpanded: boolean }

function AgentChatInfo({ isExpanded }: TAgentChatInfoProps) {
  const navigate = useNavigate()
  const { selectedAgent: agent } = useGetAgentCentralized()

  const agentId = agent?.[EAgentKeys.id] || ''
  const agentChatFriendlyUrl = agent?.[EAgentKeys.chatFriendlyUrl]
  const chatUrl = getChatUrl({ agentChatFriendlyUrl, agentId })

  const handleEditChat = () => {
    navigate(EClientPath.settingsChatbot)
  }

  const handleOpenChat = () => {
    window.open(chatUrl, '_blank')
  }

  return (
    <InfoBlock
      icon={<ChatBubble />}
      infoText={
        <>
          <p>How to use your AI assistant chat link</p>
          <ul style={{ margin: 0, paddingLeft: 16, paddingBottom: 16 }}>
            <li>
              First customize your chatbot, changing colors, adding a custom
              friendly URL and more
            </li>
            <li>Embed the chat widget on your website.</li>
            <li>
              Add the chat URL as your Link in bio to Instagram, Tiktok,
              Facebook, X, and other
            </li>
            <li>
              Print a QR code to the chat link on signage, receipts and more.
            </li>
          </ul>
        </>
      }
      title="Chat"
      value={chatUrl}
      isExpanded={isExpanded}
      actionButtons={[
        {
          icon: <ContentCopy />,
          label: 'Copy',
          variant: 'outlined',
          textToCopy: chatUrl,
        },
        {
          icon: <Edit />,
          label: 'Edit',
          variant: 'outlined',
          onClick: handleEditChat,
        },
        {
          label: 'Chat',
          variant: 'contained',
          onClick: handleOpenChat,
        },
      ]}
      onLabelClick={handleOpenChat}
    />
  )
}

export default AgentChatInfo
